import { send } from '../../../src/network/network';
import { type SignupResponse } from '../../v2/auth/signup/post/post-api-v2-auth-signup';

type Params = {
  idToken: string;
  /**
   * Marks a freemium (guest-flow) signup when this login creates an account.
   * Sent only when true so a standard login/signup payload is unchanged.
   */
  isGuestFlow?: boolean;
};

type GoogleLoginResponse = {
  created: boolean;
  customer: SignupResponse;
};

export async function postGoogleLogin({ idToken, isGuestFlow }: Params) {
  return send<GoogleLoginResponse>({
    path: '/api/google_login/',
    method: 'POST',
    body: {
      idToken,
      ...(isGuestFlow === true ? { is_guest_flow: true } : {}),
    },
  });
}
